import { Helmet } from "react-helmet";
import NewHead from "../../landing/NewHead";
import ServiceFooter from "../../ServiceFooter";
import "./realestate.css";
import { useState } from "react";

import { Navigation, A11y, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import RealestateIndustry from "./RealestateIndustry";
import { benefits, steps } from "./data";
import RealestateBenefit from "./RealestateBenefit";
import { useEffect } from "react";
import Marquee from "react-marquee-slider";

const Realestate = () => {
  const [isPrevChooseDisabled, setIsPrevChooseDisabled] = useState(true);
  const [isNextChooseDisabled, setIsNextChooseDisabled] = useState(false);
  const [rsVelocity, setRsVelocity] = useState(30);

  const [activeIndex, setActiveIndex] = useState(null);
  const [isHovered, setIsHovered] = useState(false);

  const handleShow = (index) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const handleChooseChange = (chooseSwiper) => {
    setIsPrevChooseDisabled(chooseSwiper.isBeginning);
    setIsNextChooseDisabled(chooseSwiper.isEnd);
  };

  useEffect(() => {
    const updateRsVelocity = () => {
      setRsVelocity(window.innerWidth <= 768 ? 10 : 30); // Slower on mobile
    };

    updateRsVelocity();
    window.addEventListener("resize", updateRsVelocity);
    return () => window.removeEventListener("resize", updateRsVelocity);
  }, []);

  return (
    <>
      <header>
        <NewHead />
      </header>

      <Helmet>
        <title>Real Estate Tokenization</title>

        <meta name="title" content="Real estate tokenization " />
        <meta
          name="description"
          content=" Real estate tokenization is the future of property investment, offering a secure, transparent, and efficient way to buy, sell, and trade real estate assets. Start tokenization with us."
        />

        <meta property="og:title" content="Real estate tokenization" />
        <meta property="og:site_name" content="Beleaf Technologies" />

        <link
          rel="canonical"
          href="https://www.beleaftechnologies.com/real-estate-tokenization"
        />
      </Helmet>

      <main className="rs-main">
        {/* hero */}
        <article className="rs-hero primary__landing__container">
          <div className="row mx-0 rs-hero-row">
            <div className="col-lg-6">
              <div className="rs-hero-left">
                <h1 className="rs-hero-title"> Real Estate Tokenization </h1>
                <p className="rs-hero-content">
                  2x your profit with Real estate tokenization development. Save
                  more with fractional property ownership
                </p>
                <button
                  data-toggle="modal"
                  data-target="#myModal"
                  className="primary-landing-main-btn re-hero-btn"
                >
                  <div className="re-btn-txt">Get Free Consultation</div>
                  <span className="mx-2 right-arr">
                    <i className="fa-solid fa-arrow-right"></i>
                  </span>
                </button>
              </div>
            </div>
            <div className="col-lg-6 rs-hero-col">
              <img
                src={require("../../../image/realestate/hero.webp")}
                alt="Real estate tokenization"
              />
            </div>
          </div>
        </article>

        {/* future of property*/}
        <article className="rs-mt-100  primary__landing-content-container">
          <div className="row mx-0 rs-future-row">
            <div className="col-lg-6 rs-future-col">
              <img
                src={require("../../../image/realestate/future.webp")}
                alt="Real estate tokenization"
              />
            </div>
            <div className="col-lg-6">
              <h3 className="rs-subtitle">
                Future of <span className="rs-span">Property Investment</span>{" "}
              </h3>
              <p className="rs-subcontent">
                Real estate tokenization is transforming the property investment
                market, making real estate assets more liquid, accessible, and
                efficient. By leveraging blockchain technology, real estate
                tokenization allows property owners to divide assets into
                digital tokens, enabling fractional ownership and seamless
                transactions. This innovation is opening doors for investors
                worldwide to participate in real estate markets with lower
                capital requirements and enhanced security.
              </p>
              <button
                data-toggle="modal"
                data-target="#myModal"
                className="primary-landing-main-btn"
              >
                Get Free Demo
                <span className="mx-2 right-arr">
                  <i className="fa-solid fa-arrow-right"></i>
                </span>
              </button>
            </div>
          </div>
        </article>

        {/* about */}
        <article className="rs-about rs-mt-100 primary__landing__container">
          <div className="row mx-0 rs-about-row">
            <div className="col-lg-6">
              <h3 className="rs-subtitle">
                <span className="rs-span">What is </span> Real Estate
                Tokenization?
              </h3>
              <p className="rs-subcontent rs-about-content">
                Real estate tokenization refers to the process of converting
                ownership rights of a property into digital tokens stored on a
                blockchain. These tokens represent a share in the asset, similar
                to stocks in a company. Real estate tokenization enhances
                liquidity, reduces intermediaries, and improves transparency in
                property transactions.
              </p>
              <button
                data-toggle="modal"
                data-target="#myModal"
                className="primary-landing-main-btn"
              >
                Get Quote
                <span className="mx-2 right-arr">
                  <i className="fa-solid fa-arrow-right"></i>
                </span>
              </button>
            </div>
            <div className="col-lg-6 rs-about-col">
              <img
                src={require("../../../image/realestate/about.webp")}
                alt="Real estate tokenization"
              />
            </div>
          </div>
        </article>

        {/* how real estate works */}
        <article className="rs-mt-100 primary__landing__container">
          <div className="row rs-how-works-row">
            <div className="col-lg-6 rs-how-works-col">
              <img
                src={require("../../../image/realestate/how-works.webp")}
                alt="Real estate tokenization"
              />
            </div>
            <div className="col-lg-6">
              <h3 className="rs-subtitle rs-how-max">
                How Real Estate Tokenization{" "}
                <span className="rs-span">Works</span>
              </h3>

              <div className="rs-how-right-wrap mt-3 mt-lg-5">
                <div className="rs-how-right-icon">
                  <i className="fa-solid fa-check"></i>
                </div>
                <div>
                  <h4 className="rs-how-right-title">Asset Selection</h4>
                  <p className="rs-how-right-content">
                    A real estate property is identified for tokenization.
                  </p>
                </div>
              </div>
              <div className="rs-how-right-wrap">
                <div className="rs-how-right-icon">
                  <i className="fa-solid fa-check"></i>
                </div>
                <div>
                  <h4 className="rs-how-right-title">Legal Structuring</h4>
                  <p className="rs-how-right-content">
                    Ownership rights are legally structured into digital assets.
                  </p>
                </div>
              </div>
              <div className="rs-how-right-wrap">
                <div className="rs-how-right-icon">
                  <i className="fa-solid fa-check"></i>
                </div>
                <div>
                  <h4 className="rs-how-right-title">Token Creation</h4>
                  <p className="rs-how-right-content">
                    Real estate tokens are created on a blockchain platform.
                  </p>
                </div>
              </div>
              <div className="rs-how-right-wrap">
                <div className="rs-how-right-icon">
                  <i className="fa-solid fa-check"></i>
                </div>
                <div>
                  <h4 className="rs-how-right-title">Distribution & Trading</h4>
                  <p className="rs-how-right-content">
                    Investors buy, sell, or trade tokens via tokenization
                    platforms.
                  </p>
                </div>
              </div>
              <div className="rs-how-right-wrap">
                <div className="rs-how-right-icon">
                  <i className="fa-solid fa-check"></i>
                </div>
                <div>
                  <h4 className="rs-how-right-title">
                    Ownership & Profit Sharing
                  </h4>
                  <p className="rs-how-right-content">
                    Investors receive returns based on their token ownership.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </article>

        {/* benefits */}
        <div className="rs-ben-outer">
          <article className="rs-mt-100 rs-benefits">
            <div className="primary__landing-content-container">
              <div className="row mx-0 rs-ben-row">
                <div className="col-lg-6">
                  <h3 className="rs-subtitle rs-steps-title pt-0">
                    <span className="rs-span">Benefits of</span> Real Estate
                    Tokenization
                  </h3>
                  <button
                    data-toggle="modal"
                    data-target="#myModal"
                    className="explore__card-btn mt-4"
                  >
                    Get Started{" "}
                    <span className="mx-2 right-arr">
                      <i className="fa-solid fa-arrow-right"></i>
                    </span>
                  </button>
                </div>
                <div className="col-lg-6">
                  {benefits.map((data, index) => (
                    <RealestateBenefit
                      data={data}
                      key={data.id}
                      showIndex={activeIndex === index}
                      handleShow={() => handleShow(index)}
                    />
                  ))}
                </div>
              </div>

              {/* services */}
              <div className="rs-services">
                <div className="row mx-0 rs-service-row">
                  <div className="col-lg-6">
                    <h5 className="rs-service-title">
                      Our Real Estate Tokenization Development Services
                    </h5>
                  </div>
                  <div className="col-lg-6">
                    <p className="rs-service-content">
                      As a premier real estate tokenization development company,
                      we offer end-to-end solutions to help you tokenize real
                      estate assets efficiently. Our services include
                    </p>
                  </div>
                </div>

                <img
                  src={require("../../../image/realestate/service.webp")}
                  alt="Real estate tokenization"
                  className="rs-service-image"
                />

                <div
                  onMouseEnter={() => setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}
                  className="rs-service-marquee-outer"
                >
                  <Marquee
                    velocity={isHovered ? 0 : rsVelocity}
                    direction="rtl"
                    resetAfterTries={200}
                  >
                    <div className="rs-service-marquee">
                      <h5>Consultation & Strategy Development</h5>
                    </div>
                    <div className="rs-service-marquee">
                      <h5>Smart Contract Development & Auditing</h5>
                    </div>
                    <div className="rs-service-marquee">
                      <h5>Token Creation & Management</h5>
                    </div>
                    <div className="rs-service-marquee">
                      <h5>Property Tokenization Platform Development</h5>
                    </div>
                    <div className="rs-service-marquee">
                      <h5>Regulatory Compliance Assistance</h5>
                    </div>
                    <div className="rs-service-marquee">
                      <h5>Investor Dashboard & Trading Platform Development</h5>
                    </div>
                    <div className="rs-service-marquee">
                      <h5>Consultation & Strategy Development</h5>
                    </div>
                    <div className="rs-service-marquee">
                      <h5>Smart Contract Development & Auditing</h5>
                    </div>
                  </Marquee>
                </div>
              </div>
            </div>
          </article>
        </div>

        {/* how rs changing industry */}
        <article className="rs-mt-100 primary__landing-content-container">
          <h3 className="rs-subtitle rs-change-title">
            How Real Estate Tokenization is Changing{" "}
            <span className="rs-span">the Industry</span>{" "}
          </h3>

          <div className="row mx-0 g-4 g-lg-0 rs-change-row">
            <div className="col-lg-3 col-md-6">
              <div className="rs-change-cards">
                <div className="rs-change-num">01</div>
                <h6>Democratizing Real Estate Investment</h6>
                <p>
                  Real estate tokenization allows retail investors to
                  participate in property markets that were previously dominated
                  by institutional investors.
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="rs-change-cards">
                <div className="rs-change-num">02</div>
                <h6>Enabling Cross Border Investments</h6>
                <p>
                  Investors worldwide can access lucrative real estate markets
                  without the need for complex legal procedures.
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="rs-change-cards">
                <div className="rs-change-num">03</div>
                <h6>Enhancing Property Liquidity</h6>
                <p>
                  With real estate tokenization, assets can be easily traded,
                  unlocking liquidity in traditionally illiquid markets.
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="rs-change-cards">
                <div className="rs-change-num">04</div>
                <h6>Smart Contracts for Automated Transactions</h6>
                <p>
                  Smart contracts streamline property transactions, automating
                  rental payments, revenue distribution, and ownership
                  verification.
                </p>
              </div>
            </div>
          </div>
        </article>

        {/* industries */}
        <article className="rs-industry rs-mt-100 primary__landing-content-container">
          <div>
            <h3 className="rs-choose-title rs-ind-title">
              Industries Benefiting from Real Estate Tokenization
            </h3>

            <RealestateIndustry />
          </div>
        </article>

        {/* steps */}
        <article className="rs-mt-100 rs-steps">
          <div className="primary__landing-content-container">
            <div className="row mx-0 rs-steps-row">
              <div className="col-lg-6 rs-step-left-col">
                <h3 className="rs-subtitle rs-steps-title">
                  Steps to Implement Real Estate Tokenization
                </h3>
                <button
                  data-toggle="modal"
                  data-target="#myModal"
                  className="explore__card-btn mt-4"
                >
                  Get Started{" "}
                  <span className="mx-2 right-arr">
                    <i className="fa-solid fa-arrow-right"></i>
                  </span>
                </button>

                <div>
                  <img
                    src={require("../../../image/realestate/steps-left.webp")}
                    alt="Real estate tokenization"
                    className="step-left-img"
                  />
                </div>
              </div>

              <div className="col-lg-6 rs-step-right-col">
                <div className="rs-step-card-wrap">
                  {steps.map((step, index) => (
                    <div key={index} className="rs-step-card">
                      <img src={step.imageSrc} alt="Real estate tokenization" />
                      <h4 className="rs-step-right-title">{step.title}</h4>
                      <div className="rs-step-right-flex">
                        <p className="rs-step-right-content">{step.content}</p>
                        <div className="rs-step-right-arrow">
                          <i className="fa-solid fa-arrow-right"></i>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </article>

        {/* how to pick */}
        <article className="rs-mt-100 primary__landing-content-container">
          <h3 className="rs-subtitle rs-pick-title">
            How to pick <span className="rs-span"> the Best</span> Real Estate
            Tokenization Development <span className="rs-span">Company</span>
          </h3>

          <div className="agent-our-slider rs-pick-slider">
            <Swiper
              className="agent-our-swiper "
              spaceBetween={30}
              slidesPerView={4}
              modules={[Navigation, A11y, Pagination]}
              pagination={{
                clickable: true,
              }}
              scrollbar={{ draggable: true }}
              navigation={{
                prevEl: ".agent-our-prev-arrow",
                nextEl: ".agent-our-next-arrow",
              }}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                  spaceBetween: 10,
                },
                480: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 30,
                },
                1025: {
                  slidesPerView: 3,
                  spaceBetween: 40,
                },
                1200: {
                  slidesPerView: 4,
                  spaceBetween: 30,
                },
              }}
              onSlideChange={handleChooseChange}
              onReachBeginning={() => setIsPrevChooseDisabled(true)}
              onReachEnd={() => setIsNextChooseDisabled(true)}
              onFromEdge={() => {
                setIsPrevChooseDisabled(false);
                setIsNextChooseDisabled(false);
              }}
            >
              <SwiperSlide>
                <div className="mt-5">
                  <div className="rs-pick-outer-card">
                    <div className="rs-pick-cards rs-swiper-one">
                      <div className="rs-pick-inner-content one">
                        <h5>Experience in Blockchain and Real Estate</h5>
                        <p>
                          Select a company with proven expertise in blockchain
                          development and real estate solutions.
                        </p>
                      </div>
                    </div>
                    <img
                      src={require("../../../image/realestate/pick-arrow.webp")}
                      alt="Real estate tokenization"
                      className="rs-pick-arrow"
                    />
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="mt-5">
                  <div className="rs-pick-outer-card">
                    <div className="rs-pick-cards rs-swiper-two">
                      <div className="rs-pick-inner-content ">
                        <h5>Regulatory Knowledge</h5>
                        <p>
                          Ensure the company understands and complies with real
                          estate regulations in different jurisdictions.
                        </p>
                      </div>
                    </div>
                    <img
                      src={require("../../../image/realestate/pick-arrow.webp")}
                      alt="Real estate tokenization"
                      className="rs-pick-arrow"
                    />
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="mt-5">
                  <div className="rs-pick-outer-card">
                    <div className="rs-pick-cards rs-swiper-three">
                      <div className="rs-pick-inner-content">
                        <h5>Customized Solutions</h5>
                        <p>
                          A top development company offers tailored solutions
                          that align with your business goals and investment
                          models.
                        </p>
                      </div>
                    </div>
                    <img
                      src={require("../../../image/realestate/pick-arrow.webp")}
                      alt="Real estate tokenization"
                      className="rs-pick-arrow"
                    />
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="mt-5">
                  <div className="rs-pick-outer-card">
                    <div className="rs-pick-cards rs-swiper-four">
                      <div className="rs-pick-inner-content one">
                        <h5 className="rs-pick-mw">
                          Security and Transparency
                        </h5>
                        <p>
                          The company should implement advanced security
                          protocols and ensure transparency in transactions.
                        </p>
                      </div>
                    </div>
                    <img
                      src={require("../../../image/realestate/pick-arrow.webp")}
                      alt="Real estate tokenization"
                      className="rs-pick-arrow"
                    />
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="mt-5">
                  <div className="rs-pick-outer-card">
                    <div className="rs-pick-cards rs-swiper-five">
                      <div className="rs-pick-inner-content">
                        <h5>Post-Launch Support</h5>
                        <p>
                          Ongoing technical support is essential for maintaining
                          platform functionality and security.
                        </p>
                      </div>
                    </div>
                    <img
                      src={require("../../../image/realestate/pick-arrow.webp")}
                      alt="Real estate tokenization"
                      className="rs-pick-arrow"
                    />
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>

            <div className="agent-our-btn-wrapper">
              <button
                className={`agent-our-prev-arrow ${
                  isPrevChooseDisabled ? "disabled" : ""
                }`}
                style={{
                  color: isPrevChooseDisabled ? "#23232380" : "#232323",
                  cursor: isPrevChooseDisabled ? "not-allowed" : "pointer",
                  background: isPrevChooseDisabled ? "#ffffff14" : "#ffffff23",
                }}
              >
                <i className="fa-solid fa-chevron-left"></i>
              </button>
              <button
                className={`agent-our-next-arrow ${
                  isNextChooseDisabled ? "disabled" : ""
                }`}
                style={{
                  color: isNextChooseDisabled ? "#23232380" : "#232323",
                  cursor: isNextChooseDisabled ? "not-allowed" : "pointer",
                  background: isNextChooseDisabled ? "#ffffff14" : "#ffffff23",
                }}
              >
                <i className="fa-solid fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </article>

        {/* why choose */}
        <article className="rs-choose rs-mt-100 primary__landing-content-container">
          <div className="row mx-0 rs-choose-row">
            <div className="col-lg-7 ">
              <div className="rs-choose-left-col">
                <h3 className="rs-subtitle rs-choose-title">
                  <span className="rs-span">Why Choose Us</span> as Your Real
                  Estate Tokenization Development Partner?
                </h3>
                <p className="rs-subcontent mt-4 rs-choose-content">
                  Our expertise in blockchain technology, compliance frameworks,
                  and real estate investment strategies makes us the perfect
                  partner for your tokenization needs. Here’s why businesses
                  trust us
                </p>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="rs-choose-right-outer">
                <div className="rs-choose-right-cards rs-bt-none">
                  <h5>Proven Track Record</h5>
                  <p>
                    Years of experience in blockchain and tokenization
                    development.
                  </p>
                </div>
                <div className="rs-choose-right-cards">
                  <h5>Compliance Centric Approach</h5>
                  <p>
                    Adherence to global real estate and financial regulations.
                  </p>
                </div>
                <div className="rs-choose-right-cards">
                  <h5>Customizable Solutions </h5>
                  <p>
                    Tailored platforms to suit diverse real estate investment
                    models.
                  </p>
                </div>
                <div className="rs-choose-right-cards">
                  <h5>End-to-End Development </h5>
                  <p>From consultation to deployment and ongoing support.</p>
                </div>
                <div className="rs-choose-right-cards rs-bb-none">
                  <h5>Cutting-Edge Technology</h5>
                  <p>
                    Use of advanced security protocols and blockchain networks.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </article>

        {/* future of rs */}
        <article className="rs-mt-100 primary__landing-content-container">
          <div className="row mx-0 rs-future-content-row">
            <div className="col-lg-6">
              <h3 className="rs-subtitle">
                The Future of Real Estate Tokenization
              </h3>
              <button
                data-toggle="modal"
                data-target="#myModal"
                className="primary-landing-main-btn mt-3"
              >
                Get In Touch
                <span className="mx-2 right-arr">
                  <i className="fa-solid fa-arrow-right"></i>
                </span>
              </button>
            </div>
            <div className="col-lg-6">
              <div className="rs-future-content-reveal">
                <p>
                  <span>
                    Real estate tokenization is poised to revolutionize property
                    investment by making it more inclusive, efficient, and
                    transparent. As blockchain adoption grows, real estate
                    tokenization will become a mainstream method for property
                    ownership and investment. Governments and regulatory bodies
                    are also working towards creating legal frameworks to
                    support real estate tokenization.
                  </span>
                </p>
              </div>
            </div>
          </div>
        </article>

        {/* Take Away*/}
        <div className="rs-mt-100 custom-get-in-touch ply-ta">
          <div className="primary__landing-content-container ">
            <h5 className="custom-get-title ph-take-title">Take Away</h5>
            <p className="custom-get-content">
              Real estate tokenization is reshaping the global property market
              by offering liquidity, transparency, and accessibility. As more
              investors recognize the potential of real estate tokenization, the
              industry will continue to expand, leading to a new era of real
              estate investment. Contact us today to build your custom real
              estate tokenization platform and unlock new investment
              opportunities!
            </p>

            <div className="text-center">
              <button
                data-toggle="modal"
                data-target="#myModal"
                className="fiu-need-left-btn mt-4"
              >
                Get Free Consultation{" "}
                <span className="mx-2 right-arr">
                  <i className="fa-solid fa-arrow-right"></i>
                </span>
              </button>
            </div>
          </div>
        </div>
      </main>

      {/* faq */}
      <article className="primary__landing-content-container">
        <div className="landing-faq-wrapper">
          <div className="row">
            <div className="col-lg-6">
              <h6 className="landing-faq-left-title">
                Frequently Asked <span className="faq-span">Questions.</span>{" "}
                {""}
              </h6>
            </div>
            <div className="col-lg-6">
              <div>
                <div className="container">
                  <div className="accordion" id="faq">
                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead1">
                        <button
                          className="landing-faq-title collapsed"
                          type="button"
                          data-toggle="collapse"
                          data-target="#faq1"
                          aria-expanded="true"
                          aria-controls="faq1"
                        >
                          How does tokenization benefit real estate investors?
                        </button>
                      </div>

                      <div
                        id="faq1"
                        className="collapse"
                        aria-labelledby="faqhead1"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Tokenization enables fractional ownership, enhances
                          liquidity, and removes geographical investment
                          barriers. It also increases transparency and reduces
                          transaction costs through smart contracts.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead2">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq2"
                          aria-expanded="true"
                          aria-controls="faq2"
                        >
                          Is real estate tokenization legal?
                        </div>
                      </div>

                      <div
                        id="faq2"
                        className="collapse"
                        aria-labelledby="faqhead2"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Yes, real estate tokenization is legal, but it must
                          comply with financial and real estate regulations in
                          different jurisdictions. A reliable development
                          company ensures compliance with SEC, FINMA, and other
                          authorities.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead3">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq3"
                          aria-expanded="true"
                          aria-controls="faq3"
                        >
                          How do smart contracts work in real estate
                          tokenization?
                        </div>
                      </div>

                      <div
                        id="faq3"
                        className="collapse"
                        aria-labelledby="faqhead3"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Smart contracts automate transactions, ensuring
                          security and transparency. They handle agreements like
                          property transfers, rental income distribution, and
                          compliance, reducing the need for intermediaries.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead4">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq4"
                          aria-expanded="true"
                          aria-controls="faq44"
                        >
                          How can I start a real estate tokenization project?
                        </div>
                      </div>

                      <div
                        id="faq4"
                        className="collapse"
                        aria-labelledby="faqhead4"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          To start, choose a trusted real estate tokenization
                          development company that offers end-to-end solutions.
                          They will guide you through blockchain integration,
                          regulatory compliance, and platform development.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>

      <ServiceFooter />
    </>
  );
};

export default Realestate;
